import type { CategorizationRule } from './types';

export const EXACT_MATCH_RULES: CategorizationRule[] = [
  {
    category: "Transfer",
    types: ["Deposit", "DEPOSIT"],
    exact: true,
    keywords: [
      "jpmorgan chase",
      "chase bank",
      "jpmorgan",
      "american express",
      "bank of america",
      "wells fargo",
      "citibank",
      "capital one bank",
      "discover bank",
    ],
  },
];
